// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__lvAcp","importantInfo":"styles_importantInfo__2o45Z"};